/// <amd-module name="WidgetCommon/CommonChartCacheableQueries/CommonChartResultCacheableQuery" />
import { ICacheableQuery } from "Reporting/Common/ICacheableQuery";
import { IDataTable } from "Tfs/Charting/ChartContracts";
import { ChartConfiguration } from "Tfs/Charting/Contracts/Reporting";
import { IReportingRestClient } from "Tfs/Charting/RestClient/Reporting";
import * as TfsWidgetContext from "Tfs/Widget/Context";
import { IVssPageContext } from "VSS/Platform/Context";

import * as Resources from "WidgetCommon/CommonChartCacheableQueries/Resources";

interface TeamContext {
    id: string;
    name: string;
}

export class CommonChartResultCacheableQuery implements ICacheableQuery<IDataTable> {
    private chartConfiguration: ChartConfiguration;

    constructor(private projectId: string, private featureName: string, chartConfiguration: ChartConfiguration, private teamContext: TeamContext) {
        this.chartConfiguration = chartConfiguration;
    }

    public async runQuery(pageContext: IVssPageContext): Promise<IDataTable> {
        /**
         *  WIT implementation requires some live "context" which isn't available from charting contract.
         *  This information isn't persisted with a chart, because it isn't a setting, but "live" context.
         **/

        const reportingRestClient = pageContext.getRestClient<IReportingRestClient>("IReportingRestClient");

        this.chartConfiguration.transformOptions.filterContext = {
            project: TfsWidgetContext.getProject(pageContext).name,
            projectId: this.projectId,
            teamId: this.teamContext && this.teamContext.id
        };

        if (this.chartConfiguration.transformOptions.filter == null || this.chartConfiguration.chartType == null) {
            return Promise.reject(Resources.CommonChartCacheableQueries_InvalidConfiguration);
        }

        const rawResult: any = await reportingRestClient.runTransformQuery(
            [this.chartConfiguration.transformOptions],
            this.projectId,
            this.featureName
        );
        /**
         * User should not encounter error in this case. If they do, it is probably related to
         * some bad configuration.
         */
        const results: IDataTable = rawResult.result && rawResult.result.length > 0 && rawResult.result[0];
        if (results) {
            return Promise.resolve(results);
        } else {
            return Promise.reject(Resources.CommonChartCacheableQueries_InvalidConfiguration);
        }
    }

    public getKey(): string {
        return JSON.stringify({
            projectId: this.projectId,
            featureName: this.featureName,
            transformOptions: this.chartConfiguration.transformOptions
        });
    }
}
